import React from "react";
import {
  PromotionExample,
  PromotionSelectStyles,
} from "./ChoosePromotionOption.styles";

export function ChoosePromotionOption({
  titleLines,
  previewImage,
  mode,
  setOpenedMode,
}) {
  return (
    <PromotionSelectStyles onClick={() => setOpenedMode(mode)}>
      <h2>
        {titleLines[0]}
        <br />
        {titleLines[1]}
      </h2>
      <PromotionExample url={previewImage} />
    </PromotionSelectStyles>
  );
}
